// import * as $ from "jquery";

declare const Swiper;

export default class GeckoSlideshow {
	container: HTMLElement;
	slideshow: any;

	constructor(el:HTMLElement) {
		this.container = el;
		setTimeout(() => {
			this.initSlideshow();
		}, 500);
	}

	initSlideshow() {
		let sliderOpts = {
			slidesPerView: 1,
			autoplay: 8000,
			speed: 1000,
			loop: true,
			draggable: false,
			grabCursor: false,

			keyboardControl: true,
			pagination: '.slideshow-pagination',
			paginationClickable: true,

			prevButton: '.swiper-button-prev',
			nextButton: '.swiper-button-next',

			onInit: (swiper) => {
				this.slideshow = swiper;
			},
		}
		const slideshow = new Swiper(this.container, sliderOpts);
	}
}